import { EnumBase } from 'hay-core-react';
class ConfiguracaoTipoEnvioEmailEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.tipoenvioemail.proprio',
                'main.configuracao.tipoenvioemail.smtp',
            ],
            'main.configuracao.tipoenvioemail.proprio'
        );
    }
}

const instance = new ConfiguracaoTipoEnvioEmailEnum();
export default instance;
